export function LogoFull() {
  return (
    <svg
      width="115"
      height="32"
      viewBox="-3.17 0 115 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.5434 20.6134L41.7386 19.2707C42.3431 21.1796 43.7272 22.7708 46.2123 22.7708C48.0594 22.7708 49.3019 21.71 49.3019 20.4366C49.3019 16.5829 39.3254 19.0939 39.3254 12.3398C39.3254 9.54695 41.7746 7.46124 45.6438 7.46124C49.0165 7.46124 51.8566 9.2292 52.6362 11.8453L49.441 13.188C48.9805 11.42 47.3109 10.4309 45.6774 10.4309C44.0438 10.4309 42.9092 11.1023 42.9092 12.2706C42.9092 15.7014 52.9553 13.0829 52.9553 20.4032C52.9553 23.4804 50.2566 25.848 46.2099 25.848C41.8441 25.848 39.359 23.1602 38.541 20.6158L38.5434 20.6134Z"
        fill="black"
      />
      <path
        d="M68.8256 32V23.5138C67.7246 24.9282 65.6305 25.848 63.4644 25.848C58.1031 25.848 54.8384 22.0302 54.8384 16.6546C54.8384 11.2791 57.9616 7.46124 63.2509 7.46124C65.736 7.46124 67.8301 8.55785 68.8256 10.0081V7.74555H72.6949V32H68.8256ZM69.0751 16.6546C69.0751 13.1187 67.017 10.8204 63.8914 10.8204C60.7658 10.8204 58.7076 13.1187 58.7076 16.6546C58.7076 20.1905 60.7658 22.4889 63.8914 22.4889C67.017 22.4889 69.0751 20.1547 69.0751 16.6546Z"
        fill="black"
      />
      <path
        d="M75.2158 16.6546C75.2158 11.279 78.3054 7.46122 83.7002 7.46122C86.0079 7.46122 88.102 8.48616 89.1671 9.9722V-3.05176e-05H93.0363V25.5637H89.1671V23.3012C88.3155 24.7872 86.1494 25.848 83.7698 25.848C78.303 25.848 75.2134 22.0301 75.2134 16.6546H75.2158ZM89.4525 16.6546C89.4525 13.1187 87.3944 10.8203 84.2688 10.8203C81.1432 10.8203 79.085 13.1187 79.085 16.6546C79.085 20.1905 81.1432 22.4888 84.2688 22.4888C87.3944 22.4888 89.4525 20.1547 89.4525 16.6546Z"
        fill="black"
      />
      <path
        d="M100.501 0.96278H98.532V0.0357971H103.536V0.96278H101.566V6.39088H100.499V0.96278H100.501Z"
        fill="black"
      />
      <path
        d="M104.675 0.0357971H105.906L107.938 4.86423L109.969 0.0357971H111.2V6.39088H110.18V2.02355L108.357 6.39088H107.527L105.695 2.02355V6.39088H104.675V0.0357971Z"
        fill="black"
      />
      <path
        d="M2.1589 10.512C1.42727 10.512 0.707639 10.4595 0 10.3663V16.2794C0.664461 16.3654 1.38409 16.4132 2.17089 16.4132C6.82691 16.4132 9.12014 14.7671 11.5477 13.0278C14.1456 11.1642 16.8346 9.23622 22.1863 9.23622C23.4936 9.23622 24.6402 9.3509 25.6669 9.55397V3.1965H15.8127C12.8766 7.60206 7.85359 10.5144 2.1589 10.5144V10.512Z"
        fill="black"
      />
      <path
        d="M22.1863 11.3867C17.5302 11.3867 15.237 13.0328 12.8095 14.7745C10.2116 16.638 7.52256 18.566 2.17089 18.566C1.39369 18.566 0.671657 18.523 0 18.449V28.7604H25.6669V11.757C24.6618 11.5229 23.52 11.3867 22.1863 11.3867Z"
        fill="black"
      />
      <path
        d="M0 8.19956C0.70524 8.30707 1.42487 8.36202 2.1589 8.36202C6.57264 8.36202 10.5234 6.34799 13.1333 3.19434H0V8.19717V8.19956Z"
        fill="black"
      />
    </svg>
  );
}
